export default "__VITE_ASSET___nwGYxuw__"